<div class="container">
      <h1 class="page-title">
    <span class="icon"><i class="fas fa-cog"></i></span>{{ 'Menu.Menu.FSCSSCSetting' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'FSCSSCSettingNew.New' | translate }}" [selected]="isSearchFormOpen">
        <form [formGroup]="addForm">
          <div class="p-fluid formgrid grid">
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingNew.SerialNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.seqNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'FSCSSCSettingNew.Forwarder' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="forwarder" [filter]="true" [options]="forwarderOptions" [(ngModel)]="airwaysExpense.forwarder"></p-dropdown>
                <small *ngIf="submitted && f.forwarder.errors" class="errors">
                  <div *ngIf="f.forwarder.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'FSCSSCSettingNew.CostType' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="feeType" [filter]="true" [options]="feeTypeOptions" [(ngModel)]="airwaysExpense.feeType"></p-dropdown>
                <small *ngIf="submitted && f.feeType.errors" class="errors">
                  <div *ngIf="f.feeType.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'FSCSSCSettingNew.Currency' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="currency" [filter]="true" [options]="currencyOptions" [(ngModel)]="airwaysExpense.currency"></p-dropdown>
                <small *ngIf="submitted && f.currency.errors" class="errors">
                  <div *ngIf="f.currency.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingNew.Status' | translate }}</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.status | optionsMapping:statusOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'FSCSSCSettingNew.DepartureCountry' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="fromCountry" [filter]="true" [options]="countryOptions" [(ngModel)]="airwaysExpense.fromCountry"></p-dropdown>
                <small *ngIf="submitted && f.fromCountry.errors" class="errors">
                  <div *ngIf="f.fromCountry.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'FSCSSCSettingNew.DestinationIATA' | translate }}</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="toIataArea" [filter]="true" [options]="iataAreaOptions" [(ngModel)]="airwaysExpense.toIataArea"></p-dropdown>
                <small *ngIf="submitted && f.toIataArea.errors" class="errors">
                  <div *ngIf="f.toIataArea.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'FSCSSCSettingNew.Amount' | translate }}</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="amount" [(ngModel)]="airwaysExpense.amount" mode="decimal" [minFractionDigits]="4" [maxFractionDigits]="4" [maxlength]="22"></p-inputNumber>
                <small *ngIf="submitted && f.amount.errors" class="errors">
                  <div *ngIf="f.amount.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingNew.IsValid' | translate }}</label>
              <div class="col-8 column-value">
                <p-radioButton formControlName="isActivated" name="isActivated" value="1" label="Y" [(ngModel)]="airwaysExpense.isActivated"></p-radioButton>
                <p-radioButton formControlName="isActivated" name="isActivated" value="0" label="N" [(ngModel)]="airwaysExpense.isActivated" class="ml-2"></p-radioButton>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'FSCSSCSettingNew.EffectiveStart' | translate }}</label>
              <div class="col-8 column-value">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" formControlName="startDtTimeZone" [(ngModel)]="airwaysExpense.startDtTimeZone"></p-calendar>
                <small *ngIf="submitted && f.startDtTimeZone.errors" class="errors">
                  <div *ngIf="f.startDtTimeZone.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label"><span class="requiredStart">*</span>{{ 'FSCSSCSettingNew.EffectiveEnd' | translate }}</label>
              <div class="col-8 column-value">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" formControlName="endDtTimeZone" [(ngModel)]="airwaysExpense.endDtTimeZone"></p-calendar>
                <small *ngIf="submitted && f.endDtTimeZone.errors" class="errors">
                  <div *ngIf="f.endDtTimeZone.errors.required" class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'FSCSSCSettingNew.Remarks' | translate }}</label>
              <div class="col-8 column-value">
                <input type="text" pInputText formControlName="remark" [(ngModel)]="airwaysExpense.remark" />
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtn($event)" class="mr-2"></button>
              <button pButton pRipple label="{{ 'Common.Button.ReturnWithoutSaving' | translate }}" (click)="goToLastPage()" class="mr-2"></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
  </p-card>
</div>
